'use client';

import { createModelsApi } from '../../modules/models';
import { useEnterApiDomain } from '../use-enter-api-domain';

/** 获取按当前 Provider 传输依赖创建的 models 领域客户端。 */
export function useModelsApi() {
    return useEnterApiDomain(createModelsApi);
}
